import { threeDotsElement } from './constants';

export const getPagesToShow = (
  currentPage: number,
  countPages: number,
  countPagesVisibleNearCurrentPage: number
): number[] => {
  if (countPagesVisibleNearCurrentPage < 1) throw new Error('One is minimum visible pages near current page');
  const pagesElements: number[] = [];

  const threeDotsElementNeededAfterFirstPage = currentPage - countPagesVisibleNearCurrentPage - 1 > 1;

  if (threeDotsElementNeededAfterFirstPage) {
    pagesElements.push(1);
    pagesElements.push(threeDotsElement);
    for (let pageNumber = currentPage - countPagesVisibleNearCurrentPage; pageNumber <= currentPage; pageNumber++) {
      pagesElements.push(pageNumber);
    }
  } else {
    for (let pageNumber = 1; pageNumber <= currentPage; pageNumber++) {
      pagesElements.push(pageNumber);
    }
  }

  const threeDotsElementNeededBeforeLastPage = countPages - countPagesVisibleNearCurrentPage - 1 > currentPage;

  if (threeDotsElementNeededBeforeLastPage) {
    for (let pageNumber = currentPage + 1; pageNumber <= currentPage + countPagesVisibleNearCurrentPage; pageNumber++) {
      pagesElements.push(pageNumber);
    }
    pagesElements.push(threeDotsElement);
    pagesElements.push(countPages);
  } else {
    for (let pageNumber = currentPage + 1; pageNumber <= countPages; pageNumber++) {
      pagesElements.push(pageNumber);
    }
  }

  return pagesElements;
};
